<template>
  <div>
    <div
      style="display: flex;justify-content: center;padding-top: 50px;width: 1200px;margin:50px auto;box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;;">
      <div style="width: 250px;background-color: white;padding:40px 20px;border-right: 1px solid #c6c6c6">
        <div style="display: flex;justify-content: space-between;margin-bottom: 30px">
          <div style="font-size: 18px;font-weight: 500">Task（{{ list.length }}）</div>
          <el-dropdown>
            <div
              style="font-size: 14px;font-weight: 400;color: #FB9348;padding: 5px 16px;border-radius: 6px;border: 1px solid #FB9348;display: flex;align-items: center">
              <div>New Task</div>
              <img style="height: 12px;width: 12px;margin-left: 3px" mode="aspectFill" src="../assets/img/fold.png" />
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <div @click="openHandle" style="font-size: 14px;font-weight: 400;display: flex;align-items: center">
                  <img style="height: 12px;width: 12px;" mode="aspectFill" src="../assets/img/add.png" />
                  <div style="margin-left: 3px">Gene ID</div>
                </div>
              </el-dropdown-item>
              <el-dropdown-item>
                <div @click="proteinOpenHandle"
                  style="font-size: 14px;font-weight: 400;display: flex;align-items: center">
                  <img style="height: 12px;width: 12px;" mode="aspectFill" src="../assets/img/add.png" />
                  <div style="margin-left: 3px">Protein Fasta</div>
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

        </div>
        <div @click="selectTaskHandle(item)" v-for="item in list" :key="item.id"
          style="height: 50px;display: flex;padding: 10px;border-radius: 10px"
          :style="{ backgroundColor: item.id === selectTask.id ? '#FB9348' : '', color: item.id === selectTask.id ? 'white' : '' }">
          <img style="height: 40px;width: 40px;" mode="aspectFill" src="../assets/img/taskList_list.png" />
          <div style="margin-left: 10px">
            <!--            <div style="font-size: 16px">123</div>-->
            <div style="display: flex;align-items: center;margin-top: 5px">
              <img v-if="item.status === 1" style="height: 12px;width: 12px;" mode="aspectFill"
                src="../assets/img/taskList_clock.png" />
              <img v-if="item.status === 2" style="height: 12px;width: 12px;" mode="aspectFill"
                src="../assets/img/taskList_ing.png" />
              <img v-if="item.status === 3" style="height: 12px;width: 12px;" mode="aspectFill"
                src="../assets/img/taskList_finsh.png" />
              <img v-if="item.status === 4" style="height: 12px;width: 12px;" mode="aspectFill"
                src="../assets/img/taskList_error.png" />
              <div style="font-size: 12px;color: #AAAAAA;margin-left: 5px">{{ item.taskName }}</div>
            </div>
            <div style="font-size: 12px;color: #AAAAAA;margin-top: 3px;">{{ item.createTime }}</div>
          </div>
          <div style="flex-grow: 1"></div>
          <div style="text-align: right">
            <el-dropdown @command="handleCommand(item)">
              <img style="height: 16px;width: 16px;" mode="aspectFill" src="../assets/img/taskList_more.png" />
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="delete">Delete</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
      <div style="width: 900px;background-color: white;padding:40px 20px;">
        <div style="font-size: 18px;font-weight: 500;border-bottom: 1px solid #c6c6c6;padding-bottom: 20px">Report</div>
        <div v-if="selectTask" style="position: relative">
          <div style="width: 820px;padding:30px 20px;background-color: #f3f3f3;margin-top: 30px;font-size: 14px">

            <div style="display: flex;align-items: center;">
              <div style="display: flex;">
                <div style="width: 280px"><span style="color: #666666">Species：</span>
                  <el-select :disabled="true" style="width: 200px" filterable v-model="selectTask.goodsName"
                    placeholder=" " clearable size="small">
                    <el-option v-for="item in goodsList" :key="item.value" :label="item.label" :value="item.value" />
                  </el-select>
                </div>
                <div v-if="selectTask.goodsGroup" style="width: 280px"><span style="color: #666666">Target Species
                    Group：</span>{{ selectTask.goodsGroup }}</div>
                <div v-if="selectTask.simulate" style="width: 280px"><span style="color: #666666">Simulate：</span>{{
                  selectTask.simulate }}</div>
              </div>
              <div style="display: flex;">
                <div style="width: 280px"><span style="color: #666666">Gene ID：</span>
                  <el-input :disabled="true" @blur="changeGeneId" v-model="selectTask.geneId" style="width: 200px">
                  </el-input>
                </div>
              </div>
            </div>

            <div style="margin-top: 20px;display: flex;align-items: center;">
              <div style="margin-right: 10px;color: #666666">Group：</div>
              <el-cascader filterable v-model="search.keyword" :options="speciesGroupOption" style="width: 150px"
                placeholder="Select Group" :show-all-levels="false">
              </el-cascader>
              <el-button style="margin-left: 20px;background-color: #77c9eb;border-radius: 10px;border: none;"
                type="primary" @click="searchForm">Re-Run</el-button>
              <el-button style="margin-left: 20px;background-color: #ba3030;border-radius: 10px;border: none;"
                type="primary" @click="downloadFiles">Download</el-button>
            </div>
          </div>

          <div v-if="selectTask.status === 2" style="display: flex;align-items: center;">
            <div style="margin-top: 20px;color:#5199ff;margin-right: 20px;text-align: center;width: 100%">
              Jobs is running and will be done in about 30 seconds. <br>
              This page will be refreshed automatically when the job is done. <br>
              Or you can refresh the page manually.<br>
              <el-button size="mini" type="primary" @click="refreshPage" style="margin-top: 20px">
                <i class="el-icon-refresh"></i> Refresh
              </el-button>
            </div>
          </div>
          <div v-if="selectTask.status === 3">
            <div v-if="sortedGenesData && sortedGenesData.length > 0" style="margin-top: 20px">
              <el-table :data="sortedGenesData" stripe border style="width: 860px;">
                <el-table-column v-for="key in ['species', 'geneId', 'chrom', 'geneStart', 'geneEnd', 'geneName', 'geneType', 'geneSynonym']"
                  :key="key" :prop="key" :label="key">
                </el-table-column>
              </el-table>

              <el-pagination style="text-align: right;margin-right: 25px;" layout="prev, pager, next" :current-page.sync="queryParams.pageNum" :total="total"
                @current-change="getSortedGenes(selectTask.id)">
              </el-pagination>
            </div>

            <div
              style="display: flex;margin-top: 20px;justify-content: space-between;border-bottom: 1px solid #c6c6c6;padding-bottom: 20px">
              <div style="width: 900px;">
                <div style="text-align: center;">
                  Correlation of Normalized Phylogenetic Profiles

                  <el-popover placement="top-start" width="200" trigger="hover"
                    content="This heatmap shows the correlations between the phylogenetic profiles of the output genes. The genes are clustered by their correlation pattern, which is presented in the dendrogram both in the upper and leftmost sides of the heatmap. ">
                    <i slot="reference" class="el-icon-warning"></i>
                  </el-popover>
                </div>
                <div style="margin-top: 10px;">
                  <iframe style="width:900px;height: 900px;border: none;"
                    :src="'/profile/upload/geneTask/' + selectTask.id + '/1.html'" />
                </div>
              </div>

            </div>


            <div
              style="display: flex;margin-top: 20px;justify-content: space-between;border-bottom: 1px solid #c6c6c6;padding-bottom: 20px">
              <div style="width: 900px;">
                <div style="text-align: center;">
                  Length Normalized Phylogenetic Profiles: Gene by Species
                  <el-popover placement="top-start" width="200" trigger="hover"
                    content="This heatmap shows the phylogenetic profiles of the output genes. The genes are clustered by their correlation pattern, which is presented in the dendrogram on the leftmost side of the heatmap. Each row corresponds to a gene, and each column to a species. Each pixel depicts 'Evolutionary Conservation' score of gene Y in species X. Colors illustrate the conservation values, darker (blue) means higher value.">
                    <i slot="reference" class="el-icon-warning"></i>
                  </el-popover>
                </div>
                <div style="margin-top: 10px;">
                  <img style="width: 900px;" mode="aspectFill"
                    :src="'/profile/upload/geneTask/' + selectTask.id + '/2.png'" />
                </div>
              </div>
            </div>

            <div style="margin-top:40px;border-bottom: 1px solid #c6c6c6;padding-bottom: 20px">
              <div style="text-align: center;font-size: 18px;font-weight: 500;">Length Normalized Phylogenetic Profiles:
                Gene-wise Trends</div>
              <div style="display: flex;justify-content: center;margin-top: 10px;">
                <el-select v-model="selectedGene" placeholder="Select Gene" style="width: 300px;"
                  @change="changeGeneLineplot">
                  <el-option v-for="item in lineOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div style="margin-top: 10px;position: relative;">
                <div v-if="lineLoading"
                  style="position: absolute;top: 0;left: 0;width: 100%;height: 500px;display: flex;justify-content: center;align-items: center;background-color: rgba(255,255,255,0.7);z-index: 10;">
                  <el-loading-spinner></el-loading-spinner>
                </div>
                <!-- <iframe style="width: 900px;height: 500px;border: none;" :src="lineplotUrl"
                  @load="lineLoading = false" /> -->
                <img style="height: 500px;width: 900px;display: block;" mode="aspectFill" :src="lineplotUrl" @load="lineLoading = false" @error="lineLoading = false" />
              </div>
              <div style="margin-top: 10px;">This line plot visualizes the phylogenetic profiles of the output genes,
                showing how their normalized phylogenetic profile (NPP) values vary across different species. Each line
                represents a gene, and the x-axis corresponds to species while the y-axis denotes the NPP values. This
                visualization helps in identifying trends and patterns of evolutionary conservation across species.
              </div>
            </div>

            <div style="margin-top: 40px;border-bottom: 1px solid #c6c6c6;padding-bottom: 20px">
              <div style="text-align: center;font-size: 18px;font-weight: 500;">
                GO Enrichment Analysis of Output Genes
              </div>
              <div style="width: 900px;margin-top: 20px;">
                <iframe style="width: 900px;height: 500px;border: none;"
                  :src="'/profile/upload/geneTask/' + selectTask.id + '/4.html'" />
              </div>
              <div style="margin-top: 10px;">
                This visualization presents the Gene Ontology (GO) enrichment analysis results for the output genes,
                highlighting their functional associations. The analysis is displayed in three formats:
              </div>
            </div>

            <div style="margin-top: 40px;border-bottom: 1px solid #c6c6c6;padding-bottom: 20px">
              <div style="text-align: center;font-size: 18px;font-weight: 500;">
                GO Enrichment Analysis of Output Genes
              </div>
              <div style="width: 900px;margin-top: 20px;">
                <iframe style="width: 900px;height: 500px;border: none;"
                  :src="'/profile/upload/geneTask/' + selectTask.id + '/5.html'" />
              </div>
              <div style="margin-top: 10px;">
                This visualization presents the Gene Ontology (GO) enrichment analysis results for the output genes,
                highlighting their functional associations. The analysis is displayed in three formats:
              </div>
            </div>

            <div style="margin-top: 40px;border-bottom: 1px solid #c6c6c6;padding-bottom: 20px">
              <div style="text-align: center;font-size: 18px;font-weight: 500;">
                GO Enrichment Analysis of Output Genes
              </div>
              <div style="width: 900px;margin-top: 20px;">
                <iframe style="width: 900px;height: 500px;border: none;"
                  :src="'/profile/upload/geneTask/' + selectTask.id + '/6.html'" />
              </div>
              <div style="margin-top: 10px;">
                This visualization presents the Gene Ontology (GO) enrichment analysis results for the output genes,
                highlighting their functional associations. The analysis is displayed in three formats:
              </div>
            </div>


          </div>
          <div v-if="selectTask.status === 4">
            <div style="margin-top: 20px;color:red">
              {{ selectTask.result }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog title="New Task:" :visible.sync="open" width="700px" append-to-body>
      <el-form ref="ruleForm" :model="form" :rules="rules" label-width="170px">
        <el-form-item label="Species" prop="goodsName">
          <el-select style="width: 360px" filterable v-model="form.goodsName" placeholder=" " clearable size="small">
            <el-option v-for="item in goodsList" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="Group:" prop="speciesGroup">
          <el-cascader filterable v-model="form.speciesGroup" :options="speciesGroupOption" style="width: 360px"
            placeholder=" " clearable size="small" :show-all-levels="false">
          </el-cascader>
        </el-form-item>
        <el-form-item label="Gene Id:" prop="geneId">
          <el-input @blur="changeGeneId" v-model="form.geneId" style="width: 360px">
          </el-input>
          <div v-if="form.goodsName" style="color: gray;font-size: 12px;">
            e.g. {{ getGeneFormatTip() }}
          </div>
        </el-form-item>
        <el-form-item label="Task Name:" prop="taskName">
          <el-input v-model="form.taskName" style="width: 360px">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel" size="mini">cancel</el-button>
        <el-button style="background-color: #FB9348;color: white" @click="submitForm('geneId')"
          size="mini">submit</el-button>
      </div>
    </el-dialog>

    <el-dialog title="New Task:" :visible.sync="proteinOpen" width="700px" append-to-body>
      <el-form ref="ruleForm" :model="form" :rules="rules" label-width="170px">
        <el-form-item label="Task Name:" prop="taskName">
          <el-input v-model="form.taskName" style="width: 360px" @blur="changeGeneId">
          </el-input>
        </el-form-item>
        <el-form-item label="Species Group:" prop="speciesGroup">
          <el-cascader filterable v-model="form.speciesGroup" :options="speciesGroupOption" style="width: 360px">
          </el-cascader>
        </el-form-item>
        <el-form-item label="Protein Fasta" prop="proteinFasta">
          <el-input style="width: 360px" type="textarea" :rows="5" placeholder="" v-model="form.proteinFasta">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="proteinOpen = false" size="mini">cancel</el-button>
        <el-button style="background-color: #FB9348;color: white" @click="submitFormProteinFasta('proteinFasta')"
          size="mini">BLAST</el-button>
      </div>
    </el-dialog>

    <el-dialog title="BLAST Best Hit" :visible.sync="blastOpen" width="1000px" append-to-body>
      <div>
        <el-table :data="blastHitData" border style="width: 100%">
          <el-table-column prop="taskName" label="taskName" width="110"></el-table-column>
          <el-table-column prop="Group" label="Group" width="120"></el-table-column>
          <el-table-column label="BestHit" align="center">
            <el-table-column prop="Species" label="Species"></el-table-column>
            <el-table-column prop="geneID" label="geneID"></el-table-column>
            <el-table-column prop="pident" label="pident"></el-table-column>
            <el-table-column prop="Align_length" label="Align_length"></el-table-column>
            <el-table-column prop="Mismatch" label="Mismatch"></el-table-column>
            <el-table-column prop="Evalue" label="Evalue"></el-table-column>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="blastOpen = false" size="mini">cancel</el-button>
        <el-button style="background-color: #FB9348;color: white" @click="submitBlastHit" size="mini">submit</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Plotly } from 'vue-plotly'
import JSZip from 'jszip'

export default {
  components: {
    Plotly
  },
  data() {
    return {
      blastOpen: false,
      refreshInterval: null,
      data: [],
      speciesGroupOption: [{"label":"ALL(952)","value":"ALL(952)"},{"children":[{"children":[{"children":[{"label":"Ranunculales(16)","value":"Ranunculales(16)"},{"label":"Trochodendrales(2)","value":"Trochodendrales(2)"},{"label":"Buxales(1)","value":"Buxales(1)"},{"label":"Proteales(4)","value":"Proteales(4)"}],"label":"basal eudicotyledons(23)","value":"basal eudicotyledons(23)"},{"children":[{"label":"Cornales(7)","value":"Cornales(7)"},{"label":"Ericales(42)","value":"Ericales(42)"},{"children":[{"label":"Solanales(50)","value":"Solanales(50)"},{"label":"Lamiales(54)","value":"Lamiales(54)"},{"label":"Boraginales(1)","value":"Boraginales(1)"},{"label":"Gentianales(15)","value":"Gentianales(15)"},{"label":"Garryales(1)","value":"Garryales(1)"}],"label":"lamiids(121)","value":"lamiids(121)"},{"children":[{"label":"Aquifoliales(3)","value":"Aquifoliales(3)"},{"label":"Asterales(30)","value":"Asterales(30)"},{"label":"Apiales(17)","value":"Apiales(17)"},{"label":"Dipsacales(3)","value":"Dipsacales(3)"}],"label":"campanulids(53)","value":"campanulids(53)"},{"label":"Caryophyllales(35)","value":"Caryophyllales(35)"},{"label":"Santalales(7)","value":"Santalales(7)"}],"label":"superasterids(265)","value":"superasterids(265)"},{"label":"Ceratophyllales(1)","value":"Ceratophyllales(1)"},{"children":[{"label":"Vitales(12)","value":"Vitales(12)"},{"label":"Saxifragales(8)","value":"Saxifragales(8)"},{"children":[{"label":"Fagales(30)","value":"Fagales(30)"},{"label":"Malpighiales(33)","value":"Malpighiales(33)"},{"label":"Rosales(90)","value":"Rosales(90)"},{"label":"Celastrales(2)","value":"Celastrales(2)"},{"label":"Zygophyllales(1)","value":"Zygophyllales(1)"},{"label":"Cucurbitales(19)","value":"Cucurbitales(19)"},{"label":"Oxalidales(2)","value":"Oxalidales(2)"},{"label":"Fabales(68)","value":"Fabales(68)"}],"label":"fabids(245)","value":"fabids(245)"},{"children":[{"label":"Crossosomatales(1)","value":"Crossosomatales(1)"},{"label":"Malvales(58)","value":"Malvales(58)"},{"label":"Brassicales(52)","value":"Brassicales(52)"},{"label":"Myrtales(11)","value":"Myrtales(11)"},{"label":"Sapindales(41)","value":"Sapindales(41)"}],"label":"malvids(163)","value":"malvids(163)"}],"label":"superrosids(428)","value":"superrosids(428)"}],"label":"dicotyledons(717)","value":"dicotyledons(717)"},{"children":[{"label":"Laurales(4)","value":"Laurales(4)"},{"label":"Magnoliales(3)","value":"Magnoliales(3)"},{"label":"Piperales(2)","value":"Piperales(2)"}],"label":"magnoliids(9)","value":"magnoliids(9)"},{"children":[{"label":"Alismatales(6)","value":"Alismatales(6)"},{"label":"Acorales(1)","value":"Acorales(1)"},{"children":[{"label":"Asparagales(15)","value":"Asparagales(15)"},{"label":"Dioscoreales(2)","value":"Dioscoreales(2)"}],"label":"lilioids(17)","value":"lilioids(17)"},{"children":[{"label":"Zingiberales(10)","value":"Zingiberales(10)"},{"label":"Arecales(7)","value":"Arecales(7)"},{"label":"Poales(93)","value":"Poales(93)"}],"label":"commelinids(110)","value":"commelinids(110)"}],"label":"monocotyledons(134)","value":"monocotyledons(134)"}],"label":"core angiosperms(860)","value":"core angiosperms(860)"},{"label":"Viridiplantae(81)","value":"Viridiplantae(81)"},{"label":"Rhodophyta(8)","value":"Rhodophyta(8)"},{"label":"basal angiosperms(3)","value":"basal angiosperms(3)"}],
      speciesOption: [{"label":"ALL(952)","value":"ALL(952)"},{"children":[{"children":[{"children":[{"label":"Ranunculales(16)","value":"Ranunculales(16)"},{"label":"Trochodendrales(2)","value":"Trochodendrales(2)"},{"label":"Buxales(1)","value":"Buxales(1)"},{"label":"Proteales(4)","value":"Proteales(4)"}],"label":"basal eudicotyledons(23)","value":"basal eudicotyledons(23)"},{"children":[{"label":"Cornales(7)","value":"Cornales(7)"},{"label":"Ericales(42)","value":"Ericales(42)"},{"children":[{"label":"Solanales(50)","value":"Solanales(50)"},{"label":"Lamiales(54)","value":"Lamiales(54)"},{"label":"Boraginales(1)","value":"Boraginales(1)"},{"label":"Gentianales(15)","value":"Gentianales(15)"},{"label":"Garryales(1)","value":"Garryales(1)"}],"label":"lamiids(121)","value":"lamiids(121)"},{"children":[{"label":"Aquifoliales(3)","value":"Aquifoliales(3)"},{"label":"Asterales(30)","value":"Asterales(30)"},{"label":"Apiales(17)","value":"Apiales(17)"},{"label":"Dipsacales(3)","value":"Dipsacales(3)"}],"label":"campanulids(53)","value":"campanulids(53)"},{"label":"Caryophyllales(35)","value":"Caryophyllales(35)"},{"label":"Santalales(7)","value":"Santalales(7)"}],"label":"superasterids(265)","value":"superasterids(265)"},{"label":"Ceratophyllales(1)","value":"Ceratophyllales(1)"},{"children":[{"label":"Vitales(12)","value":"Vitales(12)"},{"label":"Saxifragales(8)","value":"Saxifragales(8)"},{"children":[{"label":"Fagales(30)","value":"Fagales(30)"},{"label":"Malpighiales(33)","value":"Malpighiales(33)"},{"label":"Rosales(90)","value":"Rosales(90)"},{"label":"Celastrales(2)","value":"Celastrales(2)"},{"label":"Zygophyllales(1)","value":"Zygophyllales(1)"},{"label":"Cucurbitales(19)","value":"Cucurbitales(19)"},{"label":"Oxalidales(2)","value":"Oxalidales(2)"},{"label":"Fabales(68)","value":"Fabales(68)"}],"label":"fabids(245)","value":"fabids(245)"},{"children":[{"label":"Crossosomatales(1)","value":"Crossosomatales(1)"},{"label":"Malvales(58)","value":"Malvales(58)"},{"label":"Brassicales(52)","value":"Brassicales(52)"},{"label":"Myrtales(11)","value":"Myrtales(11)"},{"label":"Sapindales(41)","value":"Sapindales(41)"}],"label":"malvids(163)","value":"malvids(163)"}],"label":"superrosids(428)","value":"superrosids(428)"}],"label":"dicotyledons(717)","value":"dicotyledons(717)"},{"children":[{"label":"Laurales(4)","value":"Laurales(4)"},{"label":"Magnoliales(3)","value":"Magnoliales(3)"},{"label":"Piperales(2)","value":"Piperales(2)"}],"label":"magnoliids(9)","value":"magnoliids(9)"},{"children":[{"label":"Alismatales(6)","value":"Alismatales(6)"},{"label":"Acorales(1)","value":"Acorales(1)"},{"children":[{"label":"Asparagales(15)","value":"Asparagales(15)"},{"label":"Dioscoreales(2)","value":"Dioscoreales(2)"}],"label":"lilioids(17)","value":"lilioids(17)"},{"children":[{"label":"Zingiberales(10)","value":"Zingiberales(10)"},{"label":"Arecales(7)","value":"Arecales(7)"},{"label":"Poales(93)","value":"Poales(93)"}],"label":"commelinids(110)","value":"commelinids(110)"}],"label":"monocotyledons(134)","value":"monocotyledons(134)"}],"label":"core angiosperms(860)","value":"core angiosperms(860)"},{"label":"Viridiplantae(81)","value":"Viridiplantae(81)"},{"label":"Rhodophyta(8)","value":"Rhodophyta(8)"},{"label":"basal angiosperms(3)","value":"basal angiosperms(3)"}],
      layout: {
        // 添加边距设置
        width: 800,
        height: 600,
        // 优化y轴显示
        yaxis: {
          automargin: true,
          tickangle: 0
        },
        // 优化x轴显示
        xaxis: {
          automargin: true,
        }
      },
      dataObj: {},
      lang: 'CN',
      list: [],
      selectTask: '',
      open: false,
      proteinOpen: false,
      typeList: [],
      groupList: [],
      goodsList: [],
      simulateList: [],
      speciesGroupList: [],
      sortedGenesContent: '',
      sortedGenesData: [],
      form: {
        userId: '',
        taskName: '',
        taskType: '',
        goodsName: '',
        goodsGroup: '',
        simulate: '',
        geneId: '',
        proteinFasta: '',
        speciesGroup: '',
        taskName: '',
      },
      search: {
        keyword: ''
      },
      total: 0,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
      },
      rules: {
        goodsName: [
          { required: true, message: 'Select Query Species', trigger: 'blur' }
        ],
        goodsGroup: [
          { required: true, message: 'Select Target Species Group', trigger: 'blur' }
        ],
        simulate: [
          { required: true, message: 'Simulate or Not', trigger: 'blur' }
        ],
        geneId: [
          { required: true, message: 'Gene Id', trigger: 'blur' }
        ],
        proteinFasta: [
          { required: true, message: 'Protein Fasta', trigger: 'blur' }
        ],
        speciesGroup: [
          { required: true, message: 'Select Target Species Group', trigger: 'blur' }
        ],
        taskName: [
          { required: true, message: 'Task Name', trigger: 'blur' }
        ],
      },
      sortedGenes: '',

      lineOptions: [],
      selectedGene: '',
      lineplotUrl: '',
      lineLoading: false,
      blastHitData: [],
    }
  },
  watch: {
    selectTask: {
      handler(newVal) {
        if (newVal && newVal.speciesGroup) {
          // 从speciesGroupOption中查找匹配的选项路径
          this.findCascaderPath(this.speciesGroupOption, newVal.speciesGroup);
        }
        console.log('newVal', newVal)
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.form.userId = localStorage.getItem("userId");
    if (this.form.userId) {
      this.getList();
    } else {
      this.$router.push({
        path: `/login`,
      })
    }
    this.lang = "CN"
    this.groupList = [
      { value: '分组一', label: '分组一' },
      { value: '分组二', label: '分组二' },
    ]
    this.goodsList = [
      { value: 'Arabidopsis_thaliana', label: 'Arabidopsis_thaliana', geneFormat: 'ATMG01410' },
      { value: 'Glycine_max', label: 'Glycine_max', geneFormat: 'GLYMA_U045500' },
      { value: 'Nicotiana_attenuata', label: 'Nicotiana_attenuata', geneFormat: 'A4A49_66188' },
      { value: 'Nicotiana_benthamiana', label: 'Nicotiana_benthamiana', geneFormat: 'Nb01g00016' },
      { value: 'Oryza_sativa', label: 'Oryza_sativa', geneFormat: 'Os12g0641500' },
      { value: 'Triticum_aestivum', label: 'Triticum_aestivum', geneFormat: 'TraesCSU02G272807' },
      { value: 'Zea_mays', label: 'Zea_mays', geneFormat: 'Zm00001eb443030' },
    ]
    this.simulateList = [
      { value: 'TRUE', label: 'TRUE' },
      { value: 'FALSE', label: 'FALSE' },
    ]
    this.speciesGroupList = [
      { value: 'group1', label: 'group1' },
      { value: 'group2', label: 'group2' },
    ]

    this.open = true
    // 设置30秒自动刷新
    this.refreshInterval = setInterval(() => {
      this.refreshPage();
    }, 30000);
  },
  beforeDestroy() {
    // 清除定时器,防止内存泄漏
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
  },
  methods: {
    findCascaderPath(options, targetValue) {
      const cleanTarget = typeof targetValue === 'string' ? targetValue.split('(')[0] : '';
      
      let foundPath = null;
      
      const findPath = (optionsArray, path = []) => {
        for (const option of optionsArray) {
          const cleanValue = option.value.split('(')[0];
          
          const currentPath = [...path, option.value];
          if (cleanValue === cleanTarget && (!option.children || option.children.length === 0)) {
            foundPath = currentPath;
            return true;
          }
          if (cleanValue === cleanTarget) {
            foundPath = currentPath;
          }
          
          if (option.children && option.children.length > 0) {
            if (findPath(option.children, currentPath)) {
              return true;
            }
          }
        }
        return false;
      };
      
      findPath(options);
      
      if (foundPath) {
        this.search.keyword = foundPath;
      } else {
        this.search.keyword = targetValue;
      }
    },
    changeGeneId() {
      if (this.form.geneId) { // Check if geneId is not empty
         this.form.taskName = this.form.geneId; // Assign geneId to taskName
      }
      
      const allowedPattern = /[^a-zA-Z0-9\-_]/g; // 匹配非大小写英文字符、"-"、"_"
      if (allowedPattern.test(this.form.taskName)) {
          this.form.taskName = this.form.taskName.replace(allowedPattern, '_');
          this.$message.warning('Only English characters, "-", and "_" are allowed !');
  }
    },
    refreshPage() {
      this.clearRefreshTimer(); // 先清除已有定时器
      this.$http.get("/gene/task/list?userId=" + this.form.userId)
        .then(res => {
          this.list = res.data.rows
          let selectTask = this.list.find(item => item.id === this.selectTask.id)
          if (selectTask) {
            this.selectTaskHandle(selectTask, true);
            if (selectTask.status === 3 || selectTask.status === 4) {
              this.clearRefreshTimer();
            } else {
              // 重新启动定时器
              this.refreshInterval = setInterval(() => {
                this.refreshPage();
              }, 30000);
            }
          }
        })
    },
    clearRefreshTimer() {
      if (this.refreshInterval) {
        clearInterval(this.refreshInterval);
        this.refreshInterval = null;
      }
    },
    openHandle() {
      // this.$refs.ruleForm.resetFields()
      this.form.geneId = ''; // 重置 geneId 为空
      this.form.taskName = ''; // 重置 taskName 为空
      this.form.speciesGroup = ''; // 重置
      this.open = true
    },
    proteinOpenHandle() {
      // this.$refs.ruleForm.resetFields()
      this.proteinOpen = true
    },
    submitForm(taskType) {
      this.form.taskType = taskType
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          console.log('this.form', this.form)
          let form = { ...this.form }
          if (this.form.speciesGroup) {
            form.speciesGroup = this.form.speciesGroup[this.form.speciesGroup.length - 1];
          }
          console.log('form', form)
          if (this.form.goodsGroup) {
            form.goodsGroup = this.form.goodsGroup[this.form.goodsGroup.length - 1];
          }
          this.$http.post("/gene/task", form)
            .then(res => {
              if (res.data.code === 500) {
                this.$message.error(res.data.msg);
              } else {
                this.open = false
                this.proteinOpen = false
                this.$http.get("/gene/task/list?userId=" + this.form.userId)
                  .then(res => {
                    this.list = res.data.rows
                    this.selectTask = this.list[0]

                    this.$http.post("/gene/task/searchGene", { id: this.selectTask.id, speciesGroup: form.speciesGroup.split('(')[0] })

                    this.form = {
                      userId: localStorage.getItem("userId"),
                      taskName: '',
                      taskType: '',
                      goodsName: '',
                      goodsGroup: '',
                      simulate: '',
                      geneId: '',
                      proteinFasta: '',
                      speciesGroup: '',
                    }
                    this.$message.success('Job submit success!');
                    this.$refs.ruleForm.resetFields()
                  })
              }
            })
        } else {
          return false;
        }
      });
    },
    submitFormProteinFasta(taskType) {
      this.form.taskType = taskType
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
                lock: true,
                text: 'BLAST running...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

          console.log('this.form', this.form)
          let form = { ...this.form }
          let uuid = crypto.randomUUID();
          form.uuid = uuid

          if (this.form.speciesGroup) {
            form.speciesGroup = this.form.speciesGroup[this.form.speciesGroup.length - 1];
            form.speciesGroup = form.speciesGroup.split('(')[0];
          }

          this.$http.get("/common/upload/content", {
            params: {
              content: this.form.proteinFasta,
              uuid: uuid,
            }
          }).then(res => {
            this.$http.post("/gene/task/proteinFasta/ready", form)
              .then(res => {
                loading.close();

                if (res.data.code === 500) {
                  this.$message.error(res.data.msg);
                } else {
                  this.open = false
                  this.proteinOpen = false
                  
                  this.blastHitData = [];
                  const blastResultUrl = `/profile/upload/geneTask/${uuid}/${uuid}.json`;
                  
                  fetch(blastResultUrl)
                    .then(response => {
                      if (!response.ok) {
                        throw new Error('获取BLAST结果数据失败');
                      }
                      return response.json();
                    })
                    .then(data => {
                      this.blastHitData =[data]
                      this.blastOpen = true;
                    })
                    .catch(error => {
                      console.error('获取BLAST结果失败:', error);
                      this.$message.error('获取BLAST结果数据失败，请稍后重试');
                    });
                }
              })
          }).catch(error => {
            loading.close();
            this.$message.error('Upload data failed, please try again.');
          });
        } else {
          return false;
        }
      });
           
    },
    searchForm() {
      if (!this.search.keyword) {
        return
      }
      let speciesGroup = this.search.keyword[this.search.keyword.length - 1];
      this.search.speciesGroup = speciesGroup.split('(')[0];
      this.search.id = this.selectTask.id
      this.search.status = 2

      this.$http.put("/gene/task", this.search)
        .then(res => {
          if (res.data.code === 500) {
            this.$message.error(res.data.msg);
          } else {
            this.$http.get("/gene/task/list?userId=" + this.form.userId)
              .then(res => {
                this.list = res.data.rows
                this.selectTask = this.list.find(item => item.id === this.search.id)
              })
            this.$message.success('Job submit success!');

            this.$http.post("/gene/task/searchGene", { id: this.selectTask.id, speciesGroup: this.search.speciesGroup })
          }
        })
    },
    cancel() {
      this.open = false
    },
    getList() {
      this.$http.get("/gene/task/list?userId=" + this.form.userId)
        .then(res => {
          if (res.data.code === 500) {
            this.$message.error(res.data.msg);
          } else {
            this.list = res.data.rows
            if(this.list.length > 0) {
              this.selectTaskHandle(this.list[0])
            }
          }
        })
    },
    getStatus(status) {
      if (status === 1) {
        return 'Task initiating'
      } else if (status === 2) {
        return 'Task running'
      } else if (status === 3) {
        return 'Task complete'
      } else if (status === 4) {
        return 'Task anomalies'
      }
    },
    selectTaskHandle(item, isRefresh = false) {
      this.selectTask = item
      if (!isRefresh) {
        this.sortedGenesData = []
        this.total = 0
        this.queryParams.pageNum = 1
      }
      if (item.status === 3) {
        this.getSortedGenes(item.id)
        this.getLineOptions()
      }
    },
    getSortedGenes(taskId) {
      const ossUrl = `/profile/upload/geneTask/${taskId}/sorted_genes.txt`
      fetch(ossUrl)
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.text();
        })
        .then(data => {
          this.sortedGenesContent = data.replace(/\n/g, ',');
          this.$http.get("/gene/query/list",{
              params: {
                goodsName: this.form.goodsName,
                geneIds: this.sortedGenesContent,
                pageNum:this.queryParams.pageNum,
                pageSize:this.queryParams.pageSize
              }
            })
            .then(res => {
              this.sortedGenesData = res.data.rows
              this.total = res.data.total
            })
        })
        .catch(error => {
          console.error('获取文件内容时出错:', error);
          this.$message.error('获取文件内容失败');
        });
    },
    getLineOptions() {
      console.log('this.selectTask', this.selectTask)
      if(this.selectTask && this.selectTask.lineSearch) {
            const options = this.selectTask.lineSearch.split(';').map(item => {
              return {
                value: item,
                label: item
              }
            })
            this.lineOptions = options
            if(options.length > 0) {
              this.selectedGene = options[0].value
              this.updateLineplotUrl()
            }
          }
    },
    changeGeneLineplot() {
      this.lineLoading = true
      this.updateLineplotUrl()
    },
    updateLineplotUrl() {
      if(this.selectTask && this.selectTask.id && this.selectedGene) {
        this.lineplotUrl = `/profile/upload/geneTask/${this.selectTask.id}/3.lineplot/${this.selectedGene}.png`
      }
    },
    handleCommand(item) {
      this.$confirm('Are you sure you want to delete the task', 'Warning', {
        confirmButtonText: 'confirm',
        cancelButtonText: 'cancel',
        type: 'warning'
      }).then(() => {
        this.$http.delete("/gene/task/" + item.id)
          .then(res => {
            this.getList()
            this.$message({
              type: 'success',
              message: 'Delete Success!'
            });
          })
      }).catch(() => {

      });
    },
    rowStyle(row) {
      // 通过id标识来改变当前行的文字颜色
      if (row.rowIndex % 2 === 1) {
        return {
          backgroundColor: '#FFFFFF'
        };
      } else {
        return {
          backgroundColor: '#BBD5CC'
        };
      }
    },
    downloadFiles() {
      if (!this.selectTask || !this.selectTask.id) {
        this.$message.warning('请先选择一个任务');
        return;
      }

      const loading = this.$loading({
        lock: true,
        text: 'Preparing files.... Download will start automatically in ~20 seconds.',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      this.$http.get("/gene/task/getDownloadUrl?id=" + this.selectTask.id)
        .then(res => {
          console.log('res', res)
          let url = res.data.msg.replace('\\n', '');
          if (!url) {
            loading.close();
            this.$message.error('Failed in fetch download url, please try again later');
            return;
          }
          
          const link = document.createElement('a');
          link.href = url;
          console.log('link_selectTask', this.selectTask)
          link.download = `task_${this.selectTask.id}_results.zip`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          
          loading.close();
          this.$message.success('Downloading Now');
        })
        .catch(error => {
          loading.close();
          console.error('下载失败:', error);
          this.$message.error('Download Failed, please try again later.');
        });
    },
    getGeneFormatTip() {
      const selectedSpecies = this.goodsList.find(item => item.value === this.form.goodsName);
      return selectedSpecies ? selectedSpecies.geneFormat : '';
    },
    submitBlastHit() {
      this.form.taskType = 'proteinFasta'
      let form = { ...this.form }
      if (this.form.speciesGroup) {
        form.speciesGroup = this.form.speciesGroup[this.form.speciesGroup.length - 1];
      }
      if (this.form.goodsGroup) {
        form.goodsGroup = this.form.goodsGroup[this.form.goodsGroup.length - 1];
      }
      form.goodsName = this.blastHitData[0].Species
      form.speciesGroup = this.blastHitData[0].Group
      form.geneId = this.blastHitData[0].geneID

      this.$http.post("/gene/task", form)
        .then(res => {
          if (res.data.code === 500) {
            this.$message.error(res.data.msg);
          } else {
            this.open = false
            this.proteinOpen = false
            this.$http.get("/gene/task/list?userId=" + this.form.userId)
              .then(res => {
                this.list = res.data.rows
                this.selectTask = this.list[0]

                this.$http.post("/gene/task/searchGene", { id: this.selectTask.id, speciesGroup: form.speciesGroup.split('(')[0] })

                this.form = {
                  userId: localStorage.getItem("userId"),
                  taskName: '',
                  taskType: '',
                  goodsName: '',
                  goodsGroup: '',
                  simulate: '',
                  geneId: '',
                  proteinFasta: '',
                  speciesGroup: '',
                }
                this.$message.success('Job submit success!');
                this.$refs.ruleForm.resetFields()
                this.blastOpen = false
              })
          }
        })
    },
  }
}
</script>

<style>
.el-dialog {
  border-radius: 10px;
}

.el-menu-item:hover {
  background-color: #fb9348 !important;
  color: white !important;
}

.el-submenu__title:focus,
.el-submenu__title:hover {
  background-color: #fb9348 !important;
  color: white !important;
}

.el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: #fb9348 !important;
  color: white !important;
}

.el-input__inner {
  height: 40px !important;
  line-height: 40px !important;
}

.el-input--small .el-input__inner {
  height: 40px !important;
  line-height: 40px !important;
}

.el-select .el-input {
  height: auto !important;
}
</style>
